<form class="date-picker-form" [formGroup]="datepickerForm">
    <input
        #targetDatePicker
        [id]="id"
        type="text"
        class="form-control"
        formControlName="date"
        aria-label="date-picker"
        autocomplete="off"
        bsDatepicker placeholder="TT.MM.JJJJ"
        placement="bottom left"
        (focus)="onFocus()"
        (keyup)="onDatePickerKeyup($event.target['value'])"
        [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', showWeekNumbers: false }"
        [maxDate]="maxDate" [minDate]="minDate"
        [datevMessagePath]="messagePath"
        utilsMarkRequired utilsControlState utilsCheckValidity utilsValidationMessage
        [checkAdditionalControls]="checkAdditionalControls"
    />
</form>
